import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    // NOTE: You can define the basic palette of the application here
  }
});

export default theme;
